import React from 'react';

import { SOCKET_ID } from '../../model/promotions';

interface PromotionsBasecampPropsType {
  error?: {
    message: string;
  };
}

const PromotionsBasecamp: React.FC<PromotionsBasecampPropsType> = ({
  error,
}) => {
  if (error) {
    return <div data-testid="promotions-error">{error.message}</div>;
  }

  return <div data-testid="promotions" id={SOCKET_ID}></div>;
};

export default PromotionsBasecamp;
